'use strict';

/**
 * 共通ファイル添付モジュール
 * My OrderとAfter Service Care用の共通ファイル添付機能を提供
 */

// 設定定数
const CONFIG = {
    MAX_FILE_SIZE: 50 * 1024 * 1024, // 50MB
    DEFAULT_DELAY: 100,
    SELECTORS: {
        ATTACH_BUTTON: '.jsAttacheButton',
        FILE_INPUT: '.jsAttacheFile',
        DELETE_BUTTON: '.jsDeleteButton',
        APPEND_FILES: '.appendFiles',
        INVALID_FEEDBACK: '.invalid-feedback',
        FORM_GROUP: '.form-group',
        ATTACHED_FILE_TXT: '.attached-file-txt',
        ATTACHED_FILE_TXT_APPEND: '.attached-file-txt-append',
        MODAL_WRAPPER: '.modal-new-address-form-wrapper',
        DROPZONE: '.jsDropzone',
        MOBILE_FILELIST: '.jsMobileFilelist'
    },
    DRAGOVER_CLASS: 'is-dragover'
};

// エラーメッセージ定数
const ERROR_MESSAGES = {
    PROCESSING_ERROR: 'An error occurred while processing the file. Please try again.',
    INVALID_FILE: 'Invalid file.',
    EMPTY_FILE: 'Empty files cannot be selected.',
    ELEMENT_NOT_FOUND: '❌ .appendFiles element not found! Cannot display file names.',
    ADD_ELEMENT_ERROR: '❌ Error adding file name element:'
};

const BLOCKED_COMPRESSED_EXTENSIONS = [
    'zip',
    'rar',
    '7z',
    'tar',
    'gz',
    'tgz',
    'bz2',
    'tbz',
    'tbz2',
    'xz',
    'txz'
];

const BLOCKED_COMPRESSED_MIME_TYPES = [
    'application/zip',
    'application/x-zip-compressed',
    'application/x-7z-compressed',
    'application/vnd.rar',
    'application/x-rar-compressed',
    'application/x-tar',
    'application/gzip',
    'application/x-gzip',
    'application/x-bzip2',
    'application/x-xz'
];

// ファイル処理中フラグ（フォーム毎）
const fileProcessingFlags = new Map();

// 選択されたファイルを蓄積するMap（フォーム毎）
const accumulatedFiles = new Map();

// 後方互換性のための定数
const sizeLimit = CONFIG.MAX_FILE_SIZE;

/**
 * ファイル処理フラグを初期化
 */
function initializeFlags() {
    fileProcessingFlags.clear();
    accumulatedFiles.clear();
}

/**
 * クリーンアップ機能を設定
 */
function cleanupFileMap() {
    // ページアンロード時のクリーンアップ
    $(window).on('beforeunload', function() {
        accumulatedFiles.clear();
        fileProcessingFlags.clear();
    });
}

/**
 * ファイルサイズの検証
 * @param {number} fileSize - ファイルサイズ
 * @param {number} maxSize - 最大サイズ
 * @returns {boolean} サイズが有効かどうか
 */
function validateFileSize(fileSize, maxSize = CONFIG.MAX_FILE_SIZE) {
    return fileSize > 0 && fileSize <= maxSize;
}

/**
 * ファイル形式の検証
 * @param {string} fileType - ファイルタイプ
 * @param {Array<string>} allowedTypes - 許可されたファイル形式の配列
 * @returns {boolean} ファイル形式が有効かどうか
 */
function validateFileType(fileType, allowedTypes) {
    return allowedTypes && allowedTypes.includes(fileType);
}

/**
 * 圧縮ファイルかどうかの検証
 * @param {File} file - チェック対象のファイル
 * @returns {boolean} 圧縮ファイルの場合true
 */
function isCompressedFile(file) {
    const fileName = (file.name || '').toLowerCase();
    const fileType = (file.type || '').toLowerCase();
    const extension = fileName.includes('.') ? fileName.split('.').pop() : '';

    return BLOCKED_COMPRESSED_EXTENSIONS.includes(extension)
        || BLOCKED_COMPRESSED_MIME_TYPES.includes(fileType);
}

/**
 * ファイルの包括的バリデーション
 * @param {File} file - チェック対象のファイル
 * @param {jQuery} fileInputElement - ファイル入力要素
 * @returns {Object} バリデーション結果 {isValid: boolean, error: string}
 */
function isValidFile(file, fileInputElement) {
    // ファイル存在チェック
    if (!file || !file.name) {
        return { isValid: false, error: 'INVALID_FILE' };
    }
    
    // 空ファイルチェック
    if (file.size === 0) {
        return { isValid: false, error: 'EMPTY_FILE' };
    }
    
    // サイズチェック
    if (!validateFileSize(file.size)) {
        return { isValid: false, error: 'FILE_SIZE_ERROR' };
    }

    // 圧縮ファイルは許可しない
    if (isCompressedFile(file)) {
        return { isValid: false, error: 'FILE_COMPRESSED_ERROR' };
    }
    
    // 形式チェック
    const allowedTypes = $(fileInputElement).data('type')?.split(',') || [];
    if (!validateFileType(file.type, allowedTypes)) {
        return { isValid: false, error: 'FILE_TYPE_ERROR' };
    }
    
    return { isValid: true };
}


/**
 * data-filesの中身を参照してファイル名を表示するHTMLの追加
 * @param {jQuery} form - 対象のフォーム要素
 */
function showFileNames(form) {
    // null/undefined チェック
    if (!form) {
        return false;
    }

    // レガシーDOM要素をクリア
    $(CONFIG.SELECTORS.ATTACHED_FILE_TXT_APPEND).closest(CONFIG.SELECTORS.MODAL_WRAPPER).remove();

    const files = form.find('.jsAttacheFile').data('files');
    if (!files || !files.trim()) {
        showInitialMessage(form);
        return false;
    }

    const fileNames = files.split(',');
    const fileList = form.find('.support-filelist').not(CONFIG.SELECTORS.MOBILE_FILELIST);
    const appendElement = form.find(CONFIG.SELECTORS.APPEND_FILES);

    if (fileList.length) {
        // コンパクトリスト（support-filelistを持つフォーム用）
        fileList.empty();
        fileNames.forEach(fileName => {
            try {
                const li = $('<li>').addClass('support-filelist__item');
                const nameSpan = $('<span>').addClass('support-filelist__name').text(fileName);
                const deleteBtn = $('<button>')
                    .addClass('support-filelist__delete jsDeleteButton')
                    .attr('type', 'button')
                    .html('&times;');
                li.append(nameSpan).append(deleteBtn);
                fileList.append(li);
            } catch (error) {
                console.error(ERROR_MESSAGES.ADD_ELEMENT_ERROR, error);
            }
        });
    } else if (appendElement.length) {
        // レガシーアプローチ（appendFilesのみを持つフォーム用）
        form.find(CONFIG.SELECTORS.ATTACHED_FILE_TXT).text('');
        fileNames.forEach(fileName => {
            try {
                const wrapper = $('<div>').addClass('modal-new-address-form-wrapper');
                const parts = $('<div>').addClass('modal-new-address-form-parts modal-new-address-form-parts form-group');
                const nameSpan = $('<span>').addClass('attached-file-txt-append').text(fileName);
                const deleteBtn = $('<button>')
                    .addClass('button-change button-delete jsDeleteButton')
                    .attr('type', 'button')
                    .text('Delete');
                parts.append(nameSpan).append(deleteBtn);
                wrapper.append(parts);
                appendElement.append(wrapper);
            } catch (error) {
                console.error(ERROR_MESSAGES.ADD_ELEMENT_ERROR, error);
            }
        });
    } else {
        console.error(ERROR_MESSAGES.ELEMENT_NOT_FOUND);
        return false;
    }

    // モバイルファイルリストを同期
    const mobileList = form.find(CONFIG.SELECTORS.MOBILE_FILELIST);
    if (mobileList.length) {
        mobileList.empty();
        fileNames.forEach(fileName => {
            const li = $('<li>').addClass('support-filelist__item');
            const nameSpan = $('<span>').addClass('support-filelist__name').text(fileName);
            const deleteBtn = $('<button>')
                .addClass('support-filelist__delete jsDeleteButton')
                .attr('type', 'button')
                .html('&times;');
            li.append(nameSpan).append(deleteBtn);
            mobileList.append(li);
        });
    }
}

/**
 * 初期メッセージを表示
 * @param {jQuery} form - 対象のフォーム要素
 */
function showInitialMessage(form) {
    if (!form) {
        return;
    }

    const fileList = form.find('.support-filelist').not(CONFIG.SELECTORS.MOBILE_FILELIST);
    if (fileList.length) {
        fileList.html('<li class="attached-file-txt">No file selected yet.</li>');
    } else {
        form.find(CONFIG.SELECTORS.ATTACHED_FILE_TXT).text('No file selected yet.');
    }
    form.find(CONFIG.SELECTORS.MOBILE_FILELIST).html('<li class="attached-file-txt">No file selected yet.</li>');
}

/**
 * ファイル名の表示の初期化
 * @param {jQuery} form - 対象のフォーム要素
 */
function clearFileName(form) {
    // null/undefined チェック
    if (!form) {
        return;
    }
    
    // ファイル名の表示用の要素を削除
    $(form).find(CONFIG.SELECTORS.ATTACHED_FILE_TXT_APPEND).closest(CONFIG.SELECTORS.MODAL_WRAPPER).remove();
    // 初期メッセージを表示
    showInitialMessage(form);
    $(form).find(CONFIG.SELECTORS.FILE_INPUT).val('');
    $(form).find(CONFIG.SELECTORS.FILE_INPUT).data('files', '');
    
    // 蓄積ファイルもクリア
    const formId = form.attr('class') || form.attr('id') || 'default';
    if (accumulatedFiles.has(formId)) {
        accumulatedFiles.set(formId, []);
    }
}

/**
 * エラー時専用のファイル名表示クリア（ファイル入力はクリアしない）
 * @param {jQuery} form - 対象のフォーム要素
 */
function clearFileNameForError(form) {
    // null/undefined チェック
    if (!form) {
        return;
    }

    $(form).find(CONFIG.SELECTORS.ATTACHED_FILE_TXT_APPEND).closest(CONFIG.SELECTORS.MODAL_WRAPPER).remove();
    showInitialMessage(form); // モバイルリストも内部でリセット
    // ファイル入力はクリアしない（val('')を呼ばない）
    $(form).find(CONFIG.SELECTORS.FILE_INPUT).data('files', '');
}

/**
 * ファイル添付ボタンのクリックハンドラー
 * @param {jQuery.Event} e - イベントオブジェクト
 */
function handleAttachButtonClick(e) {
    // イベントのデフォルト動作を防止
    e.preventDefault();
    e.stopPropagation();
    
    const form = $(this).closest('form');
    const fileInput = form.find(CONFIG.SELECTORS.FILE_INPUT);
    const currentFiles = fileInput.data('files');
    const maxLength = parseInt(fileInput.data('max-length'), 10);
    
    // 既に上限に達している場合はファイル選択ダイアログを開かない
    if (currentFiles && currentFiles.trim() && currentFiles.split(',').filter(f => f.trim()).length >= maxLength) {
        fileInput.parents(CONFIG.SELECTORS.FORM_GROUP).find(CONFIG.SELECTORS.INVALID_FEEDBACK).text(fileInput.data('max-error'));
        fileInput.addClass('is-invalid');
        return false;
    }
    
    // エラー状態をクリア
    fileInput.parents(CONFIG.SELECTORS.FORM_GROUP).find(CONFIG.SELECTORS.INVALID_FEEDBACK).text('');
    fileInput.removeClass('is-invalid');
    
    fileInput.trigger('click');
}

/**
 * ファイル選択時のchangeハンドラー
 * @param {jQuery.Event} e - イベントオブジェクト
 */
function handleFileChange(e) {
    try {
        e.stopPropagation();
        if (!this.files.length) {
            return false;
        }
    
        const form = $(this).closest('form');
        const formId = form.attr('class') || form.attr('id') || 'default';
        
        // 既に処理中の場合は無視
        if (fileProcessingFlags.get(formId)) {
            return false;
        }
        fileProcessingFlags.set(formId, true);
        $(this).parents(CONFIG.SELECTORS.FORM_GROUP).find(CONFIG.SELECTORS.INVALID_FEEDBACK).text('');
        
        // ファイル配列の変換とバリデーションを同時に実行
        const filesArray = Array.from(this.files);
        const validFiles = [];
        const errorFiles = [];
        
        for (const file of filesArray) {
            const validationResult = isValidFile(file, this);
            if (validationResult.isValid) {
                validFiles.push(file);
            } else {
                errorFiles.push({ file, error: validationResult.error });
            }
        }

        // 最大ファイル数の取得
        const maxLength = parseInt($(this).data('max-length'), 10);
        
        // バリデーションエラーのハンドリング
        if (errorFiles.length > 0) {
            // エラータイプに応じて適切なメッセージを表示
            let errorMessage;
            const firstError = errorFiles[0].error;
            
            switch (firstError) {
                case 'FILE_SIZE_ERROR':
                    errorMessage = $(this).data('size-error');
                    break;
                case 'EMPTY_FILE':
                    errorMessage = ERROR_MESSAGES.EMPTY_FILE;
                    break;
                case 'FILE_TYPE_ERROR':
                case 'FILE_COMPRESSED_ERROR':
                    errorMessage = $(this).data('type-error') || $(this).data('size-error') || 'File type not supported.';
                    break;
                case 'INVALID_FILE':
                default:
                    errorMessage = ERROR_MESSAGES.INVALID_FILE;
                    break;
            }
            
            $(this).parents(CONFIG.SELECTORS.FORM_GROUP).find(CONFIG.SELECTORS.INVALID_FEEDBACK).text(errorMessage);
            $(this).addClass('is-invalid');
            
            // エラーファイルの場合、ファイル入力をクリアして再選択を可能にする
            $(this).val('');
            
            fileProcessingFlags.set(formId, false);
            return false;
        } else {
            // エラーがない場合、is-invalid クラスを削除
            $(this).removeClass('is-invalid');
        }

        // フォーム用の蓄積ファイル配列を取得または初期化
        if (!accumulatedFiles.has(formId)) {
            accumulatedFiles.set(formId, []);
        }
        const formFiles = accumulatedFiles.get(formId);
        
        // 重複を除いた新規ファイルのリストを作成
        const newFilesToAdd = validFiles.filter(file => 
            !formFiles.some(existingFile => existingFile.name === file.name)
        );
        
        // 事前上限チェック（既存 + 新規 > 上限）
        if (formFiles.length + newFilesToAdd.length > maxLength) {
            $(this).parents(CONFIG.SELECTORS.FORM_GROUP).find(CONFIG.SELECTORS.INVALID_FEEDBACK).text($(this).data('max-error'));
            $(this).addClass('is-invalid');
            // 既存ファイルは保持し、エラーメッセージのみ表示
            fileProcessingFlags.set(formId, false);
            return false;
        }
        
        // 上限内の場合のみ蓄積に追加
        formFiles.push(...newFilesToAdd);
        
        // ファイル名配列を作成
        const allFileNames = formFiles.map(f => f.name);
        
        // 有効なファイルがある場合のみデータを設定
        if (allFileNames.length > 0) {
            const fileNamesString = allFileNames.join();
            $(this).data('files', fileNamesString);
            showFileNames(form);
        } else {
            // 有効なファイルがない場合（サイズ・形式エラーのみの場合）
            $(this).data('files', '');
            clearFileNameForError(form);
        }
        
        // 処理完了フラグをリセット
        fileProcessingFlags.set(formId, false);
        return false;
        
    } catch (error) {
        console.error('❌ Error occurred in file change event:', error);
        console.error('Error stack:', error.stack);
        
        // エラー時もフラグをリセット
        const form = $(this).closest('form');
        const formId = form.attr('class') || form.attr('id') || 'default';
        fileProcessingFlags.set(formId, false);
        
        // ファイル選択をクリア
        $(this).val('');
        $(this).data('files', '');
        
        // エラーメッセージを表示
        $(this).parents(CONFIG.SELECTORS.FORM_GROUP).find(CONFIG.SELECTORS.INVALID_FEEDBACK).text(ERROR_MESSAGES.PROCESSING_ERROR);
        $(this).addClass('is-invalid');
        
        return false;
    }
}

/**
 * ドロップゾーンのクリックハンドラー（ボタン以外をクリックした場合にファイル選択を開く）
 * @param {jQuery.Event} e - イベントオブジェクト
 */
function handleDropzoneClick(e) {
    if ($(e.target).closest(CONFIG.SELECTORS.ATTACH_BUTTON).length) {
        return;
    }
    // Ignore synthetic clicks that originated from the file input itself
    // (triggered by fileInput.trigger('click') inside handleAttachButtonClick).
    // Without this guard, e.preventDefault() would cancel the native file picker.
    if ($(e.target).is(CONFIG.SELECTORS.FILE_INPUT)) {
        return;
    }

    const fileInput = $(this).find(CONFIG.SELECTORS.FILE_INPUT);
    handleAttachButtonClick.call(fileInput.get(0), e);
}

/**
 * ドラッグ中のハンドラー
 * @param {jQuery.Event} e - イベントオブジェクト
 */
function handleDropzoneDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).addClass(CONFIG.DRAGOVER_CLASS);
}

/**
 * ドラッグ離脱時のハンドラー
 * @param {jQuery.Event} e - イベントオブジェクト
 */
function handleDropzoneDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).removeClass(CONFIG.DRAGOVER_CLASS);
}

/**
 * ファイルドロップ時のハンドラー
 * @param {jQuery.Event} e - イベントオブジェクト
 */
function handleDropzoneDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).removeClass(CONFIG.DRAGOVER_CLASS);

    const droppedFiles = e.originalEvent && e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files;
    if (!droppedFiles || !droppedFiles.length) {
        return;
    }

    const fileInput = $(this).find(CONFIG.SELECTORS.FILE_INPUT);
    try {
        const dt = new DataTransfer();
        Array.from(droppedFiles).forEach(f => dt.items.add(f));
        fileInput.get(0).files = dt.files;
    } catch (err) {
        fileInput.get(0).files = droppedFiles;
    }
    fileInput.trigger('change');
}

/**
 * ファイル削除ボタンのクリックハンドラー
 * @param {jQuery.Event} e - イベントオブジェクト
 */
function handleDeleteButtonClick(e) {
    const form = $(this).closest('form');
    const fileInput = form.find(CONFIG.SELECTORS.FILE_INPUT);
    fileInput.parents(CONFIG.SELECTORS.FORM_GROUP).find(CONFIG.SELECTORS.INVALID_FEEDBACK).text('');
    fileInput.removeClass('is-invalid'); // エラー状態をクリア
    const files = fileInput.data('files');
    if (!files) return false;
    const removeValue = $(this).prev().text();
    
    // data-filesから削除対象を削除
    const result = files.split(',').filter(fileName => fileName !== removeValue);
    fileInput.data('files', result.join());
    
    // 蓄積ファイルからも削除
    const formId = form.attr('class') || form.attr('id') || 'default';
    if (accumulatedFiles.has(formId)) {
        const formFiles = accumulatedFiles.get(formId);
        const index = formFiles.findIndex(f => f.name === removeValue);
        if (index !== -1) {
            formFiles.splice(index, 1);
        }
    }

    // Reset input value so the browser fires 'change' if the same file is re-selected
    fileInput.val('');

    showFileNames(form);
    return false;
}

/**
 * ファイル添付イベントハンドラーを設定
 */
function setupFileEventHandlers() {
    
    // ファイル添付ボタン押下時
    $(CONFIG.SELECTORS.ATTACH_BUTTON)
        .off('click.fileAttachment')
        .on('click.fileAttachment', handleAttachButtonClick);

    // ファイル選択時の処理
    $(CONFIG.SELECTORS.FILE_INPUT)
        .off('change.fileAttachment')
        .on('change.fileAttachment', handleFileChange);

    // ファイル削除時の処理
    $('body')
        .off('click.fileAttachment', CONFIG.SELECTORS.DELETE_BUTTON)
        .on('click.fileAttachment', CONFIG.SELECTORS.DELETE_BUTTON, handleDeleteButtonClick);

    // ドラッグ＆ドロップ領域の処理
    $(CONFIG.SELECTORS.DROPZONE)
        .off('click.fileAttachment dragover.fileAttachment dragleave.fileAttachment drop.fileAttachment')
        .on('click.fileAttachment', handleDropzoneClick)
        .on('dragover.fileAttachment', handleDropzoneDragOver)
        .on('dragleave.fileAttachment', handleDropzoneDragLeave)
        .on('drop.fileAttachment', handleDropzoneDrop);
}


/**
 * フォーム送信時のファイルデータを取得
 * @param {string} formId - フォームID
 * @returns {Array} 蓄積されたファイル配列
 */
function getAccumulatedFiles(formId) {
    return accumulatedFiles.get(formId) || [];
}

/**
 * ファイル添付機能を初期化
 */
function initializeFileAttachment() {
    initializeFlags();
    cleanupFileMap();
    
    // 初期メッセージを全てのファイル入力要素に表示
    $(CONFIG.SELECTORS.FILE_INPUT).each(function() {
        const form = $(this).closest('form');
        showInitialMessage(form);
    });
    
    // より確実なイベント設定のため、少し遅延させる
    setTimeout(function() {
        setupFileEventHandlers();
    }, CONFIG.DEFAULT_DELAY);
}

module.exports = {
    // 公開API
    initializeFileAttachment,
    clearFileName,
    showFileNames,
    showInitialMessage,
    getAccumulatedFiles,
    
    // 設定定数
    sizeLimit: CONFIG.MAX_FILE_SIZE,
    
    // 新しい設定オブジェクト
    CONFIG,
    ERROR_MESSAGES
};
